// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Logo-module--cls1--1XaUK","cls2":"styles-Logo-module--cls2--S9Fty styles-Logo-module--cls1--1XaUK"};